import { render } from "./TrocarSenha.vue?vue&type=template&id=6a35e86a&scoped=true"
import script from "./TrocarSenha.vue?vue&type=script&lang=js"
export * from "./TrocarSenha.vue?vue&type=script&lang=js"

import "@siop/standard-libui/dist/css/bootstrap-4/siop.css?vue&type=style&index=0&id=6a35e86a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a35e86a"]])

export default __exports__